<app-header [forceLightBackground]="true"></app-header>
<div class="provider-dashboard">
  <div class="provider-dashboard--layout">
    <app-provider-sidebar class="provider-dashboard--sidebar"></app-provider-sidebar>
    <div class="provider-dashboard--content">
      <div class="page-container">
        <app-dataset-provider-dashboard></app-dataset-provider-dashboard>
      </div>
    </div>
  </div>
</div>
